import { useSearchParams } from 'react-router-dom';
import { routes } from '@platform/core/lib/routes';
import type { IRecordViewProps } from './IRecordViewProps';
import { RecordLayout } from './RecordLayout';
import { useDraftValidator } from './useDraftValidator';
import { useRecordEditor } from './useRecordEditor';
import { useRecordGuard } from './useRecordGuard';

/**
 * Сторінка збереженого запису (прототип v4): запис відкривається для перегляду; «Редагувати» вмикає чернетку (PATCH лише змінених полів),
 * вихід зі сторінки з незбереженими змінами питає підтвердження. `?edit=1` — одразу в режимі редагування.
 */
export function RecordView(props: IRecordViewProps) {
  const { ws, module, rt, record } = props;
  const [params] = useSearchParams();
  const validate = useDraftValidator(rt, record);
  const editor = useRecordEditor(ws, rt.key, record, { editing: params.get('edit') === '1', validate });
  const guard = useRecordGuard(editor, routes.record(module.module.key, rt.key, record.id));
  return <RecordLayout {...props} editor={editor} guard={guard} />;
}
